import scalpDataClassABImage from 'app/assets/images/Class_A_B.png';
import scalpDataClassCDImage from 'app/assets/images/Class_C_D.png';
import scalpDataClassEFImage from 'app/assets/images/Class_E_F.png';
// import touhiClassAImage from 'app/assets/images/touhiimage-a.png';
import touhiClassAImage from 'app/assets/images/touhiimage-a-new.png';
import touhiClassBImage from 'app/assets/images/touhiimage-a-new.png';
import touhiClassCImage from 'app/assets/images/touhiimage-a-new.png';
import touhiClassDImage from 'app/assets/images/touhiimage-a-new.png';
import touhiClassEImage from 'app/assets/images/touhiimage-a-new.png';
export const CLUSTER = {
  A_CLASS: '1',
  B_CLASS: '2',
  C_CLASS: '3',
  D_CLASS: '4',
  E_CLASS: '5',
  AB_CLASS: '6',
  BA_CLASS: '7',
  AC_CLASS: '8',
  CA_CLASS: '9',
  BD_CLASS: '10',
  DB_CLASS: '11',
  CD_CLASS: '12',
  DC_CLASS: '13',
  DE_CLASS: '14',
  ED_CLASS: '15',
  F_CLASS: '16',
};

export const EVALUATION_BACKGROUND_COLOR_BY_CLUSTER = {
  [CLUSTER.A_CLASS]: '#F7FCFF',
  [CLUSTER.B_CLASS]: '#F7FCFF',
  [CLUSTER.C_CLASS]: '#FFFBEB',
  [CLUSTER.D_CLASS]: '#FFF7ED',
  [CLUSTER.E_CLASS]: '#FEF2F2',
  [CLUSTER.AB_CLASS]: '#F7FCFF',
  [CLUSTER.BA_CLASS]: '#F7FCFF',
  [CLUSTER.AC_CLASS]: '#FFFBEB',
  [CLUSTER.CA_CLASS]: '#FFF7ED',
  [CLUSTER.BD_CLASS]: '#FEF2F2',
  [CLUSTER.DB_CLASS]: '#F7FCFF',
  [CLUSTER.CD_CLASS]: '#F7FCFF',
  [CLUSTER.DC_CLASS]: '#FFFBEB',
  [CLUSTER.DE_CLASS]: '#FFF7ED',
  [CLUSTER.ED_CLASS]: '#FEF2F2',
  [CLUSTER.F_CLASS]: '#E28E88B3',
};

export const BACKGROUND_COLOR_BY_CLUSTER = {
  [CLUSTER.A_CLASS]: '#00B3ED4D',
  [CLUSTER.B_CLASS]: '#BCD3D1B3',
  [CLUSTER.C_CLASS]: '#E8E2B7B3',
  [CLUSTER.D_CLASS]: '#E8CEA5B3',
  [CLUSTER.E_CLASS]: '#E5393526',
  [CLUSTER.AB_CLASS]: '#00B3ED4D',
  [CLUSTER.BA_CLASS]: '#BCD3D1B3',
  [CLUSTER.AC_CLASS]: '#E8E2B7B3',
  [CLUSTER.CA_CLASS]: '#E8CEA5B3',
  [CLUSTER.BD_CLASS]: '#E5393526',
  [CLUSTER.DB_CLASS]: '#00B3ED4D',
  [CLUSTER.CD_CLASS]: '#BCD3D1B3',
  [CLUSTER.DC_CLASS]: '#E8E2B7B3',
  [CLUSTER.DE_CLASS]: '#E8CEA5B3',
  [CLUSTER.ED_CLASS]: '#E5393526',
  [CLUSTER.F_CLASS]: '#E28E88B3',
};

export const TITLE_COLOR_BY_CLUSTER = {
  [CLUSTER.A_CLASS]: '#1E293B',
  [CLUSTER.B_CLASS]: '#1E293B',
  [CLUSTER.C_CLASS]: '#7F3E18',
  [CLUSTER.D_CLASS]: '#7D2700',
  [CLUSTER.E_CLASS]: '#E53935',
  [CLUSTER.AB_CLASS]: '#1E293B',
  [CLUSTER.BA_CLASS]: '#1E293B',
  [CLUSTER.AC_CLASS]: '#7F3E18',
  [CLUSTER.CA_CLASS]: '#7D2700',
  [CLUSTER.BD_CLASS]: '#E53935',
  [CLUSTER.DB_CLASS]: '#1E293B',
  [CLUSTER.CD_CLASS]: '#1E293B',
  [CLUSTER.DC_CLASS]: '#7F3E18',
  [CLUSTER.DE_CLASS]: '#7D2700',
  [CLUSTER.ED_CLASS]: '#E53935',
  [CLUSTER.F_CLASS]: '#E28E88B3',
};

export const DESC_COLOR_BY_CLUSTER = {
  [CLUSTER.A_CLASS]: '#64748B',
  [CLUSTER.B_CLASS]: '#64748B',
  [CLUSTER.C_CLASS]: '#475569',
  [CLUSTER.D_CLASS]: '#9A3412',
  [CLUSTER.E_CLASS]: '#475569',
  [CLUSTER.AB_CLASS]: '#64748B',
  [CLUSTER.BA_CLASS]: '#64748B',
  [CLUSTER.AC_CLASS]: '#475569',
  [CLUSTER.CA_CLASS]: '#9A3412',
  [CLUSTER.BD_CLASS]: '#475569',
  [CLUSTER.DB_CLASS]: '#64748B',
  [CLUSTER.CD_CLASS]: '#64748B',
  [CLUSTER.DC_CLASS]: '#475569',
  [CLUSTER.DE_CLASS]: '#9A3412',
  [CLUSTER.ED_CLASS]: '#475569',
  [CLUSTER.F_CLASS]: '#E28E88B3',
};

export const SECTION_TITLE_COLOR_BY_CLUSTER = {
  [CLUSTER.A_CLASS]: '#0096D4',
  [CLUSTER.B_CLASS]: '#0096D4',
  [CLUSTER.C_CLASS]: '#D97706',
  [CLUSTER.D_CLASS]: '#FB8C00',
  [CLUSTER.E_CLASS]: '#E53935',
  [CLUSTER.AB_CLASS]: '#0096D4',
  [CLUSTER.BA_CLASS]: '#0096D4',
  [CLUSTER.AC_CLASS]: '#D97706',
  [CLUSTER.CA_CLASS]: '#FB8C00',
  [CLUSTER.BD_CLASS]: '#E53935',
  [CLUSTER.DB_CLASS]: '#0096D4',
  [CLUSTER.CD_CLASS]: '#0096D4',
  [CLUSTER.DC_CLASS]: '#D97706',
  [CLUSTER.DE_CLASS]: '#FB8C00',
  [CLUSTER.ED_CLASS]: '#E53935',
  [CLUSTER.F_CLASS]: '#E28E88B3',
};

export const EVALUATION_BORDER_COLOR_BY_CLUSTER = {
  [CLUSTER.A_CLASS]: '#E0F2FE',
  [CLUSTER.B_CLASS]: '#E0F2FE',
  [CLUSTER.C_CLASS]: '#FEF3C7',
  [CLUSTER.D_CLASS]: '#FFEDD5',
  [CLUSTER.E_CLASS]: '#FEE2E2',
  [CLUSTER.AB_CLASS]: '#E0F2FE',
  [CLUSTER.BA_CLASS]: '#E0F2FE',
  [CLUSTER.AC_CLASS]: '#FEF3C7',
  [CLUSTER.CA_CLASS]: '#FFEDD5',
  [CLUSTER.BD_CLASS]: '#FEE2E2',
  [CLUSTER.DB_CLASS]: '#E0F2FE',
  [CLUSTER.CD_CLASS]: '#E0F2FE',
  [CLUSTER.DC_CLASS]: '#FEF3C7',
  [CLUSTER.DE_CLASS]: '#FFEDD5',
  [CLUSTER.ED_CLASS]: '#FEE2E2',
  [CLUSTER.F_CLASS]: '#C53125',
};

export const BORDER_COLOR_BY_CLUSTER = {
  [CLUSTER.A_CLASS]: '#0ea5e9',
  [CLUSTER.B_CLASS]: '#20957E',
  [CLUSTER.C_CLASS]: '#FBC02D',
  [CLUSTER.D_CLASS]: '#FB8C00',
  [CLUSTER.E_CLASS]: '#E53935',
  [CLUSTER.AB_CLASS]: '#0ea5e9',
  [CLUSTER.BA_CLASS]: '#20957E',
  [CLUSTER.AC_CLASS]: '#FBC02D',
  [CLUSTER.CA_CLASS]: '#FB8C00',
  [CLUSTER.BD_CLASS]: '#E53935',
  [CLUSTER.DB_CLASS]: '#0ea5e9',
  [CLUSTER.CD_CLASS]: '#20957E',
  [CLUSTER.DC_CLASS]: '#FBC02D',
  [CLUSTER.DE_CLASS]: '#FB8C00',
  [CLUSTER.ED_CLASS]: '#E53935',
  [CLUSTER.F_CLASS]: '#C53125',
};

export const AVERAGE_VALUE_BY_CLUSTER = {
  // update A ~ E
  [CLUSTER.A_CLASS]: [6.51, 7.43, 7.39],
  [CLUSTER.B_CLASS]: [5.13, 5.37, 5.65],
  [CLUSTER.C_CLASS]: [4.92, 3.02, 7.53],
  [CLUSTER.D_CLASS]: [4.74, 2.51, 4.08],
  [CLUSTER.E_CLASS]: [2.74, 4.97, 7.85],
  [CLUSTER.AB_CLASS]: [6.51, 7.43, 7.39],
  [CLUSTER.BA_CLASS]: [5.13, 5.37, 5.65],
  [CLUSTER.AC_CLASS]: [4.92, 3.02, 7.53],
  [CLUSTER.CA_CLASS]: [4.74, 2.51, 4.08],
  [CLUSTER.BD_CLASS]: [2.74, 4.97, 7.85],
  [CLUSTER.DB_CLASS]: [6.51, 7.43, 7.39],
  [CLUSTER.CD_CLASS]: [5.13, 5.37, 5.65],
  [CLUSTER.DC_CLASS]: [4.92, 3.02, 7.53],
  [CLUSTER.DE_CLASS]: [4.74, 2.51, 4.08],
  [CLUSTER.ED_CLASS]: [2.74, 4.97, 7.85],
  [CLUSTER.F_CLASS]: [2.48, 2.96, 5.11],
};

export const AVERAGE_SCORE_BY_CLUSTER = {
  [CLUSTER.A_CLASS]: [8.896, 9.414, 7.657],
  [CLUSTER.B_CLASS]: [6.456, 8.386, 3.728],
  [CLUSTER.C_CLASS]: [4.317, 5.193, 7.301],
  [CLUSTER.D_CLASS]: [5.725, 3.104, 1.841],
  [CLUSTER.E_CLASS]: [1.906, 3.47, 2.135],
};

export const IMAGE_URL_BY_CLUSTER = {
  [CLUSTER.A_CLASS]: scalpDataClassABImage,
  [CLUSTER.B_CLASS]: scalpDataClassABImage,
  [CLUSTER.C_CLASS]: scalpDataClassCDImage,
  [CLUSTER.D_CLASS]: scalpDataClassCDImage,
  [CLUSTER.E_CLASS]: scalpDataClassEFImage,
  [CLUSTER.AB_CLASS]: scalpDataClassABImage,
  [CLUSTER.BA_CLASS]: scalpDataClassABImage,
  [CLUSTER.AC_CLASS]: scalpDataClassCDImage,
  [CLUSTER.CA_CLASS]: scalpDataClassCDImage,
  [CLUSTER.BD_CLASS]: scalpDataClassEFImage,
  [CLUSTER.DB_CLASS]: scalpDataClassABImage,
  [CLUSTER.CD_CLASS]: scalpDataClassABImage,
  [CLUSTER.DC_CLASS]: scalpDataClassCDImage,
  [CLUSTER.DE_CLASS]: scalpDataClassCDImage,
  [CLUSTER.ED_CLASS]: scalpDataClassEFImage,
  [CLUSTER.F_CLASS]: scalpDataClassEFImage,
};

export const IMAGE_URL_TOUHI_CLASS = {
  [CLUSTER.A_CLASS]: touhiClassAImage,
  [CLUSTER.B_CLASS]: touhiClassBImage,
  [CLUSTER.C_CLASS]: touhiClassCImage,
  [CLUSTER.D_CLASS]: touhiClassDImage,
  [CLUSTER.E_CLASS]: touhiClassEImage,
  [CLUSTER.AB_CLASS]: touhiClassAImage,
  [CLUSTER.BA_CLASS]: touhiClassBImage,
  [CLUSTER.AC_CLASS]: touhiClassCImage,
  [CLUSTER.CA_CLASS]: touhiClassDImage,
  [CLUSTER.BD_CLASS]: touhiClassEImage,
  [CLUSTER.DB_CLASS]: touhiClassAImage,
  [CLUSTER.CD_CLASS]: touhiClassBImage,
  [CLUSTER.DC_CLASS]: touhiClassCImage,
  [CLUSTER.DE_CLASS]: touhiClassDImage,
  [CLUSTER.ED_CLASS]: touhiClassEImage,
};

export const THUMB_BACKGROUND_BY_CLUSTER = {
  [CLUSTER.A_CLASS]: '#00C853',
  [CLUSTER.B_CLASS]: '#00ACC1',
  [CLUSTER.C_CLASS]: '#FBC02D',
  [CLUSTER.D_CLASS]: '#FB8C00',
  [CLUSTER.E_CLASS]: '#E53935',
  [CLUSTER.AB_CLASS]: '#00C853',   // A
  [CLUSTER.BA_CLASS]: '#00ACC1',   // B
  [CLUSTER.AC_CLASS]: '#FBC02D',   // C
  [CLUSTER.CA_CLASS]: '#FB8C00',   // D
  [CLUSTER.BD_CLASS]: '#E53935',   // E
  [CLUSTER.DB_CLASS]: '#00C853',   // A
  [CLUSTER.CD_CLASS]: '#00ACC1',   // B
  [CLUSTER.DC_CLASS]: '#FBC02D',   // C
  [CLUSTER.DE_CLASS]: '#FB8C00',   // D
  [CLUSTER.ED_CLASS]: '#E53935',   // E
  [CLUSTER.F_CLASS]: '#E53935',
};

export const TEXT_BY_CLUSTER = {
  [CLUSTER.A_CLASS]: 'A',
  [CLUSTER.B_CLASS]: 'B',
  [CLUSTER.C_CLASS]: 'C',
  [CLUSTER.D_CLASS]: 'D',
  [CLUSTER.E_CLASS]: 'E',
  [CLUSTER.AB_CLASS]: 'AB',
  [CLUSTER.BA_CLASS]: 'BA',
  [CLUSTER.AC_CLASS]: 'AC',
  [CLUSTER.CA_CLASS]: 'CA',
  [CLUSTER.BD_CLASS]: 'BD',
  [CLUSTER.DB_CLASS]: 'DB',
  [CLUSTER.CD_CLASS]: 'CD',
  [CLUSTER.DC_CLASS]: 'DC',
  [CLUSTER.DE_CLASS]: 'DE',
  [CLUSTER.ED_CLASS]: 'ED',
  [CLUSTER.F_CLASS]: 'F',
};

export const DEFAULT_INFO = {
  THUMB_BACKGROUND: '#000',
  IMAGE_URL: scalpDataClassEFImage,
  TEXT: '?',
};

export const DEFAULT_RADAR_DATA = {
  // labels: ["細胞面積", "多重剥離", "カルボニル"],
  labels: ['TO', 'OX', 'DR'],
  datasets: [
    {
      label: '# of Votes',
      data: [0, 0, 0],
      backgroundColor: 'rgba(157, 193, 226, 0.7)',
    },
    {
      label: 'middle line',
      data: [5, 5, 5],
      order: 3,
      borderColor: '#e5e7eb',
      backgroundColor: 'transparent',
      borderWidth: 2,
      borderDash: [5, 5],
      pointStyle: false,
    },
  ],
};

export const EXPECTED_HEIGHT = 500;
export const EXPECTED_RATIO = 4 / 3;

// Personalization Options for NiitaAdvice
export const HAIR_OPTIONS = [
  { value: 'normal', label: '普通' },
  { value: 'thick', label: '太い' },
  { value: 'thin', label: '細い' },
];

export const GENDER_OPTIONS = [
  { value: 'female', label: '女性' },
  { value: 'male', label: '男性' },
  { value: 'other', label: 'その他' },
];

export const AGE_OPTIONS = [
  { value: 20, label: '20代' },
  { value: 30, label: '30代' },
  { value: 40, label: '40代' },
  { value: 50, label: '50代' },
];

